/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import InnerbarDashboardController from '../../common/components/InnerBarDashboard/InnerbarDashboardController';
import notifBanner from '../../assets/images/notifBanner.svg';
import PlainSearchCard from '../../common/components/PlainSearchCard';
import { DataGrid } from '@mui/x-data-grid';
import { fonts } from '../../common/themes/themes';
import './Notification.css';
import GetPayHistoryActionBox from '../../common/components/ActionIcons/GetPayHistoryActionBox/GetPayHistoryActionBox';
import NotificationViewModalController from '../../common/Modals/Notification/NotificationViewModalController';
import moment from 'moment';
import { DateField } from '../../components';
import { baseDateFormatting, baseTimeFormatting } from '../../common/helper';

interface propsType {
  notificationData: any;
  setTextFilterSearch: (Data: any) => void;
  setEmpAttachedDoc: any;
  trans?: any;
  i18n?: any;
  calltoupdateread: any;
}
const NotificationPresenter: React.FC<propsType> = ({
  notificationData,
  setTextFilterSearch,
  i18n,
  trans,
  calltoupdateread,
}) => {
  const [pageSize, setPageSize] = React.useState<number>(10);

  const [openModal, setOpenModal] = useState(false);
  const [ViewNotiData, setViewNotiData] = useState();

  const handleViewNotification = (id: any) => {
    setOpenModal(true);
    setViewNotiData(id);
  };

  const tableColumns: any = [
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      align: 'center',
      width: 300,
      renderCell: (params: any) => {
        const today: any = moment(new Date()).format('DD MMM YYYY');
        const NotifDate: any = moment(params?.row?.date).format('DD MMM YYYY');
        return (
          <div
            style={{
              display: 'flex',
            }}
          >
            {today === NotifDate ? (
              i18n.t('Today')
            ) : (
              <DateField
                value={params?.row?.date}
                format={baseDateFormatting}
              />
            )}
            {' - '}
            <DateField value={params?.row?.date} format={baseTimeFormatting} />
          </div>
        );
      },
    },
    {
      field: 'content',
      headerName: '',
      width: 300,
      renderCell: (params: any) => {
        return (
          <>
            <Grid container style={{ marginTop: '1.5em' }}>
              <Grid
                item
                xs={12}
                style={{ marginTop: '0.5em', marginBottom: '0.5em' }}
              >
                <Typography
                  style={{
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.subtitle,
                    fontWeight: fonts.fontWeight,
                  }}
                >
                  {params?.row?.subject
                    ? params?.row?.subject
                    : params?.row?.message}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    color: '#9E9E9E',
                    fontFamily: fonts.fontFamily,
                    fontSize: fonts.title,
                    fontWeight: fonts.fontWeight,
                  }}
                >
                  {params.value}
                </Typography>
              </Grid>
            </Grid>
          </>
        );
      },
    },
    {
      field: 'action',
      headerName: '',
      align: 'center',
      flex: 1,
      width: 300,
      renderCell: (params: any) => {
        return (
          <GetPayHistoryActionBox
            onView={() => {
              handleViewNotification(params);
            }}
          />
        );
      },
    },
  ];

  return (
    <>
      <Grid
        container
        style={{
          height: '100%',
          marginTop: '4em',
          width: '100vw',
          paddingRight: i18n.language == 'ar' ? '' : '8em',
        }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          style={{
            display: 'flex',
          }}
        >
          <Grid
            container
            style={{
              display: 'flex',
              flexWrap: 'nowrap',
            }}
          >
            <Grid
              item
              xs={2}
              sm={2}
              md={2}
              lg={2}
              style={{
                marginRight: i18n.language == 'ar' ? '6em' : '',
                minWidth: '15em',
              }}
            >
              <InnerbarDashboardController />
            </Grid>

            <Grid
              item
              xs={10}
              sm={10}
              md={10}
              lg={10}
              sx={{
                //display: "flex",
                backgroundColor: '#F5F5FA',
                width: 'auto',
                height: 'auto',
                padding: '1.75em',
              }}
            >
              <Grid container style={{ marginBottom: '-2em' }}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Box
                    style={{
                      backgroundImage: `url(${notifBanner})`,
                      backgroundSize: '100%',
                      backgroundPosition: 'top',
                      backgroundRepeat: 'no-repeat',

                      flexDirection: 'row',
                      width: '100%',

                      height: '152px',
                    }}
                  >
                    <Grid container>
                      <Grid item xs={4}></Grid>
                      <Grid item style={{ marginTop: '4em' }}>
                        <Box
                          style={{
                            width: '380px',
                          }}
                        >
                          <PlainSearchCard
                            onChange={(e: any) => {
                              setTextFilterSearch(e);
                            }}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
              </Grid>

              <Grid container>
                <Grid
                  item
                  sm={12}
                  md={12}
                  lg={12}
                  style={{ backgroundColor: 'white' }}
                >
                  <DataGrid
                    sx={{
                      fontSize: fonts.subtitle,
                      color: '#081735',
                      fontFamily: fonts.fontFamily,
                      resizable: 'true',
                      border: 0,
                      height: '730px',
                    }}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20, 30, 40]}
                    disableSelectionOnClick
                    rows={notificationData}
                    columns={tableColumns}
                    getRowHeight={() => 'auto'}
                    headerHeight={0}
                    componentsProps={{
                      pagination: {
                        labelRowsPerPage: trans('Rows per page'),
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {openModal && (
        <NotificationViewModalController
          isModalOpen={openModal}
          closeModal={() => {
            setOpenModal(false);
            calltoupdateread(ViewNotiData);
          }}
          notificationViewData={ViewNotiData}
          trans={trans}
        />
      )}
    </>
  );
};

export default NotificationPresenter;
